import { Component } from '@angular/core';

/**
 * This component provides a page not authorized panel.
 */
@Component({
  selector: 'site-affiliate-not-authorized',
  templateUrl: './site-affiliate-not-authorized.component.html',
  standalone: false
})
export class SiteAffiliateNotAuthorizedComponent {

}
